import React from 'react';
import { observer } from 'mobx-react-lite';
import { CallStackResolution, CallStackResolutions, CallStackResolutionExamples, CallStackResolutionDefault } from './CallStackResolution';


export const CallStackResolutionSelectorView = observer(({
	defaultValue = CallStackResolutionDefault, set,
}: {
	defaultValue: CallStackResolution | undefined;
	set: (callStackResolution: CallStackResolution) => void;
}) => {
	return (
		<select defaultValue={defaultValue} onChange={e => set(e.currentTarget.value as CallStackResolution)}>{
			CallStackResolutions.map(resolution => (
				<option key={resolution} value={resolution}>{CallStackResolutionExamples[resolution]}</option>
		))}
		</select>);

});
